export default "/images/88e951d95bb10d334faade43c7807862.avif";